import { ApiService } from '@/services/ApiService';
import {
  UrgentNotificationDto,
  UserNotificationsApi,
  UserNotificationsResultDto
} from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';

export default class NotificationApiService {
  private static instance: NotificationApiService;

  public static singleton(): NotificationApiService {
    if (!this.instance) {
      this.instance = new NotificationApiService();
    }
    return this.instance;
  }

  private constructor() {
    this.api = ApiService.wrap(UserNotificationsApi);
  }

  private api: UserNotificationsApi;

  public async fetchUrgentNotification(): Promise<UrgentNotificationDto> {
    if (ConfigService.isLoggedIn() && ConfigService.currentCustomerIdOrNull != null) {
      return this.api.findUrgentNotification(
        ConfigService.getTenant(),
        ConfigService.currentCustomerId
      );
    }

    return null;
  }

  public async markAsRead(dto: UrgentNotificationDto): Promise<Response> {
    return this.api.markNotificationsRead([dto.mostRecentUnread.id]);
  }

  public async markAsReadBatch(ids: number[]): Promise<Response> {
    return this.api.markNotificationsRead(ids);
  }

  public async fetchUserNotifications(
    currentPage: number,
    perPage: number,
    typeFilterId: number | null
  ): Promise<UserNotificationsResultDto> {
    return this.api.listUserNotifications(
      ConfigService.getTenant(),
      ConfigService.currentCustomerId,
      currentPage,
      perPage,
      typeFilterId
    );
  }

  public async fetchUnreadCount(): Promise<number> {
    return this.api.findUnreadNotificationCount();
  }

}
